import React from 'react';

export default class MainImage extends React.Component {
  render() {
    const { img, children, containerStyle, overlayStyle, innerDivStyle, className } = this.props;
    return (
      <div style={{ backgroundImage: `url(${img})`, ...containerStyle }} className={`${className} custom-image main-image`}>
        <div style={overlayStyle} className="overlay" />
        <div style={innerDivStyle} className="inner-container">
          {children}
        </div>
      </div>
    );
  }
}

export class InlineImage extends React.Component {
  render() {
    const { img, children, containerStyle, overlayStyle, innerDivStyle, className } = this.props;
    return (
      <div style={{ position: 'relative', overflow: 'hidden', ...containerStyle }} className={`${className} custom-image`}>
        <img src={img} alt="" />
        <div style={overlayStyle} className="overlay" />
        <div style={{ width: '100%', ...innerDivStyle }} className="inner-container">
          {children}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/MainImage.js